export {Nl2BrPipeModule} from './src/nl2br-pipe.module';
export {Nl2BrPipe} from './src/nl2br.pipe';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
